import { render, staticRenderFns } from "./input-token.vue?vue&type=template&id=4b721137&scoped=true"
import script from "./input-token.vue?vue&type=script&lang=js"
export * from "./input-token.vue?vue&type=script&lang=js"
import style0 from "./input-token.vue?vue&type=style&index=0&id=4b721137&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b721137",
  null
  
)

export default component.exports